import { createReactiveContext } from '../../../../../helpers/reactiveContext';

const {
  Provider: StateProvider,
  useSelector: useStateSelector,
  useMethods: useStateControllers,
} = createReactiveContext();

export { StateProvider, useStateSelector, useStateControllers };
